import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const ArticleActionsContainer = styled.div`
    ${cssMediaQueryBreakpoints.medium} {
        flex-direction: column;
    }

    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`
